import config from '@/config';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';

const BACKGROUND_IMAGE_TRANSFORM = 'w=640,blur=60';

function getArtworkImageId(artwork) {
  return artwork?.artwork_media?.artwork_main_picture?.image_id ?? '';
}

function getBackgroundImageUrl(imageId) {
  if (!imageId) {
    return '';
  }

  return `${config.app.imageServiceDomain}/${imageId}/${BACKGROUND_IMAGE_TRANSFORM}`;
}

export default function PlayArtlistSlide({ artwork, isFocused }) {
  const imageId = getArtworkImageId(artwork);
  const artworkClassName = `play-artlist-slide__artwork${isFocused ? ' play-artlist-slide__artwork--focused' : ''}`;

  return (
    <div className="play-artlist-slide">
      {imageId && (
        <>
          <img
            aria-hidden="true"
            alt=""
            className="play-artlist-slide__background"
            decoding="async"
            draggable="false"
            loading="lazy"
            src={getBackgroundImageUrl(imageId)}
          />
          <div aria-hidden="true" className="play-artlist-slide__background-scrim" />
        </>
      )}

      <ArtworkImage
        artworkData={artwork}
        image={imageId}
        imageClassName={artworkClassName}
        imageTemplateClassName={artworkClassName}
      />
    </div>
  );
}
